import { render, staticRenderFns } from "./Game3.vue?vue&type=template&id=c0d5fbd4&scoped=true&"
import script from "./Game3.vue?vue&type=script&lang=js&"
export * from "./Game3.vue?vue&type=script&lang=js&"
import style0 from "./Game3.vue?vue&type=style&index=0&id=c0d5fbd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d5fbd4",
  null
  
)

export default component.exports